// Currency utility functions
const CURRENCY_SYMBOLS = {
  'USD': '$',
  'AUD': 'A$',
  'EUR': '€',
  'GBP': '£',
  'JPY': '¥',
  'CAD': 'C$',
  'CHF': 'CHF',
  'CNY': '¥',
  'SEK': 'kr',
  'NZD': 'NZ$',
  'MXN': '$',
  'SGD': 'S$',
  'HKD': 'HK$',
  'NOK': 'kr',
  'PHP': '₱'
};

const CURRENCY_LOCALES = {
  'USD': 'en-US',
  'AUD': 'en-AU',
  'EUR': 'de-DE',
  'GBP': 'en-GB',
  'JPY': 'ja-JP',
  'CAD': 'en-CA',
  'CHF': 'de-CH',
  'CNY': 'zh-CN',
  'SEK': 'sv-SE',
  'NZD': 'en-NZ',
  'MXN': 'es-MX',
  'SGD': 'en-SG',
  'HKD': 'en-HK',
  'NOK': 'nb-NO',
  'PHP': 'en-PH'
};

// Get currency symbol for a given currency code
export const getCurrencySymbol = (currencyCode = 'USD') => {
  return CURRENCY_SYMBOLS[currencyCode.toUpperCase()] || '$';
};

// Format amount with currency symbol
export const formatCurrency = (amount, currencyCode = 'USD', options = {}) => {
  const {
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
    showSymbol = true
  } = options;

  if (amount === null || amount === undefined || isNaN(amount)) {
    return showSymbol ? `${getCurrencySymbol(currencyCode)}0.00` : '0.00';
  }

  const locale = CURRENCY_LOCALES[currencyCode.toUpperCase()] || 'en-US';

  const formatted = new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits,
    maximumFractionDigits
  }).format(Math.abs(amount));

  const symbol = showSymbol ? getCurrencySymbol(currencyCode) : '';
  const sign = amount < 0 ? '-' : '';

  return `${sign}${symbol}${formatted}`;
};

// Format amount with currency symbol (no decimals for whole numbers)
export const formatCurrencyCompact = (amount, currencyCode = 'USD') => {
  if (amount === null || amount === undefined || isNaN(amount)) {
    return `${getCurrencySymbol(currencyCode)}0`;
  }

  const absAmount = Math.abs(amount);
  const symbol = getCurrencySymbol(currencyCode);
  const sign = amount < 0 ? '-' : '';

  if (absAmount >= 1000000) {
    return `${sign}${symbol}${(absAmount / 1000000).toFixed(1)}M`;
  } else if (absAmount >= 1000) {
    return `${sign}${symbol}${(absAmount / 1000).toFixed(1)}K`;
  } else {
    return `${sign}${symbol}${absAmount.toFixed(0)}`;
  }
};

// Parse a currency string and return the numeric value
export const parseCurrency = (currencyString, currencyCode = 'USD') => {
  if (!currencyString) return 0;

  const symbol = getCurrencySymbol(currencyCode);
  const cleanString = currencyString
    .replace(symbol, '')
    .replace(/,/g, '')
    .replace(/\s/g, '')
    .trim();

  return parseFloat(cleanString) || 0;
};

export default {
  getCurrencySymbol,
  formatCurrency,
  formatCurrencyCompact,
  parseCurrency
};
